<template>

<!--  <div v-if="isLoggedIn" id="header" :model="appMenu">-->

    <div class="wrap_header">
      <div class="menubar">
        <ul>
<!--          <li><RouterLink to ='/searchParaclinical'><span class="p-menuitem-icon pi pi-fw pi-search" data-pc-section="icon"></span>Tra cứu CLS</RouterLink></li>-->
        </ul>
      </div>
<!--      <div class="logouts">-->
<!--        <Button label="Đăng xuất" @click="logout" icon="pi pi-sign-out" iconPos="right" class="p-button-secondary"/>-->
<!--      </div>-->
    </div>
<!--  </div>-->
  <div v-if="isLoggedIn" id="fotter">

    <div class="wrap_header">
      <p class="coppyi">© Copyright 2024 - Bệnh viện Y học cổ truyền thành phố Đà Nẵng- Designed by voontv@gmail.com</p>
    </div>
  </div>
</template>

<script lang="ts">
import {computed, ref} from 'vue'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast";
import router from "@/router";

export default {
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const store = useStore();
    const toast = useToast();
    const permission = ref(false);
    const cls = ref(false);
    console.log("@@@@@#############$$$$$$$$$$$$$ topnav : ");
    const appMenu = computed(() => {
      const menu = ref([
        {
          label:'Gởi tin nhắn',
          icon:'pi pi-fw pi-send',
          to: '/sendmessage'
        },
        {
          label:'Đăng hình ảnh',
          icon:'pi pi-fw pi-upload',
          to: '/uploadImage'
        },
        {
          label:'Thêm nhóm',
          icon:'pi pi-fw pi-plus-circle',
          to: '/addGroup'
        },
        {
          label:'Nhân viên hỗ trợ đặt lịch khám',
          icon:'pi pi-fw pi-comments',
          to: '/addManagerBookingPage'
        },
        {
          label:'Danh sách đăng ký khám bệnh',
          icon:'pi pi-fw pi-list',
          to: '/listRegisterService'
        },
        {
          label:'Nhân viên nhận báo cáo',
          icon:'pi pi-fw pi-bars',
          to: '/addReceiverReportPage'
        },
        {
          label:'Thêm nhân viên hỗ trợ',
          icon:'pi pi-fw pi-user-plus',
          to: '/addemployee'
        },
        {
          label:'Danh sách nhân viên',
          icon:'pi pi-fw pi-users',
          to: '/showlistemployee'
        },
        {
          label:'Quản lý nhóm',
          icon:'pi pi-fw pi-users',
          to: '/managergroup'
        },
        {
          label:'Quản lý nghỉ phép',
          icon:'pi pi-fw pi-list',
          to: '/showlistdayoff'
        },
        {
          label:'Nhận thông báo checkin',
          icon:'pi pi-fw pi-map-marker',
          to: '/addManagerCheckinPage'
        },
        {
          label:'Thêm nhân viên checkin',
          icon:'pi pi-fw pi-user-plus',
          to: '/addEmployeeCheckinPage'
        },
        {
          label:'Quản lý checkin',
          icon:'pi pi-fw pi-list pi-map-marker',
          to: '/showListCheckIn'
        },
        {
          label:'Quản lý xe',
          icon:'pi pi-fw pi-car',
          to: '/carPage'
        },
      ]);
      const menuUser = ref([
        // {
        //   label:'Gởi tin nhắn',
        //   icon:'pi pi-fw pi-send',
        //   to: '/sendmessage'
        // },
        // {
        //   label:'Đăng hình ảnh',
        //   icon:'pi pi-fw pi-upload',
        //   to: '/uploadImage'
        // },
        // {
        //   label:'Thêm nhóm',
        //   icon:'pi pi-fw pi-plus-circle',
        //   to: '/addGroup'
        // },
        {
          label:'Nhân viên hỗ trợ đặt lịch khám',
          icon:'pi pi-fw pi-comments',
          to: '/addManagerBookingPage'
        },
        {
          label:'Danh sách đăng ký khám bệnh',
          icon:'pi pi-fw pi-list',
          to: '/listRegisterService'
        },
        // {
        //   label:'Nhân viên nhận báo cáo',
        //   icon:'pi pi-fw pi-bars',
        //   to: '/addReceiverReportPage'
        // },
        // {
        //   label:'Thêm nhân viên hỗ trợ',
        //   icon:'pi pi-fw pi-user-plus',
        //   to: '/addemployee'
        // },
        // {
        //   label:'Danh sách nhân viên',
        //   icon:'pi pi-fw pi-users',
        //   to: '/showlistemployee'
        // },
        // {
        //   label:'Quản lý nhóm',
        //   icon:'pi pi-fw pi-users',
        //   to: '/managergroup'
        // },
        // {
        //   label:'Quản lý nghỉ phép',
        //   icon:'pi pi-fw pi-list',
        //   to: '/showlistdayoff'
        // },
        // {
        //   label:'Nhận thông báo checkin',
        //   icon:'pi pi-fw pi-map-marker',
        //   to: '/addManagerCheckinPage'
        // },
        // {
        //   label:'Quản lý checkin',
        //   icon:'pi pi-fw pi-list pi-map-marker',
        //   to: '/showListCheckIn'
        // },
        // {
        //   label:'Quản lý xe',
        //   icon:'pi pi-fw pi-car',
        //   to: '/carPage'
        // },
      ]);
      const menuDefault = ref([
        {
          label:'Quản lý nghỉ phép',
          icon:'pi pi-fw pi-list',
          to: '/showlistdayoff'
        }
      ]);
      console.log("###########@@@@@@@@@@ check menu store.state.token: " + store.state.token);
      if(!!store.state.token) {
        console.log("###########@@@@@@@@@@ check menu store.state.permission: " + store.state.permission);
        if((store.state.permission == 'admin'))
        {
          console.log("###########@@@@@@@@@@ check menu admin: ");
          permission.value = true;
          cls.value = false;
          return menu.value;
        }
        else if(store.state.permission == 'user')
        {
          console.log("###########@@@@@@@@@@ check menu user: ");
          permission.value = false;
          return menuUser.value;
          cls.value = false;
        }
        else if(store.state.permission == 'cls' || store.state.permission == 'pk')
        {
          console.log("###########@@@@@@@@@@ check menu cls: ");
          cls.value = true;
          return menuUser.value;
        }
        return menuDefault.value;
      }
      else
        return menuDefault.value;
      // console.log("@@@@@#############$$$$$$$$$$$$$ check store.state.permission : " + store.state.permission);
      // if(store.state.permission == "admin")
      // {
      //   console.log("@@@@@#############$$$$$$$$$$$$$ check permission admin: " );
      //   permission.value = true;
      // }
      // else
      // {
      //   console.log("@@@@@#############$$$$$$$$$$$$$ check permission user: " );
      //   permission.value = false;
      // }
    });
    const logout = () => {
      store.dispatch('clearToken');
      store.dispatch('clearPermission');
      router.push({
        name: 'login',
      });
      toast.add({
        severity:'success',
        summary: 'Đăng xuất',
        detail:'Đã xóa thông tin đăng nhập thành công',
        life: 1000
      });
    }
    const gotoLoginPage = () => {
      router.push({
        name: 'login',
      });
    }

    return {
      appMenu,
      logout,
      gotoLoginPage,
      permission,
      cls
    }
  }
}
</script>

<style scoped lang="scss">
.p-menubar{
  width: 100%;
  background: white;
  border-radius: 0;
}
a{
  text-decoration: none;
}
</style>
